export default __webpack_public_path__ + "static/media/1238d9f4b4eab7f63e1b0b99c6760328.svg";